import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useVehicleStepReport } from 'api';
import { DateRange } from 'common/DateRange';
import strings from 'common/strings';
import Button from 'components/shared/Button';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import { DealerStepReportSummaryItem } from 'models';

import { StepReportTable } from './StepReportTable';

import './VehicleStepReportModalV3.scss';

export interface VehicleStepReportModalV3Props {
  showModal: boolean;
  onClose: any;
  dateRange: DateRange;
  step: DealerStepReportSummaryItem;
  tenantId?: string;
  selectedVehicleState?: string;
}

const VehicleStepReportModalV3: FC<VehicleStepReportModalV3Props> = ({
  onClose,
  showModal,
  dateRange,
  step,
  tenantId,
  selectedVehicleState,
}) => {
  const { data, isLoading } = useVehicleStepReport({
    dateRange,
    stepId: step.stepId,
    tenantId,
    selectedVehicleState,
  });

  function closeModal() {
    onClose();
  }

  const selectedVehicles = data?.data ?? [];

  return (
    <>
      <Modal
        centered
        size="xl"
        show={showModal}
        onHide={closeModal}
        className="VehicleStepReportModalV3"
      >
        <Modal.Header>
          <Modal.Title>
            {step === null ? strings.TOTAL_COMPLETED : step.stepName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <LoadingIndicator />
          ) : (
            <StepReportTable selectedVehicles={selectedVehicles} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="button" onClick={closeModal}>
            {strings.CLOSE}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VehicleStepReportModalV3;
